module.exports = __webpack_public_path__ + "static/media/cooperative-partnerC.751546d4.png";